import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  makeStyles,
} from '@material-ui/core'
import { NxTypography } from '@playvs-inc/nexus-components'
import { CaretDown } from '@playvs-inc/nexus-icons'
import React, { useState } from 'react'
import * as analytics from '@plvs/respawn/features/analytics'
import { useUserIdentityFn } from '@plvs/client-data/hooks'

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: 'auto',
    borderRadius: theme.mixins.cornerRadius['border-radius-10'],
    boxShadow: theme.shadows[1],
    '&:hover': {
      boxShadow: theme.shadows[3],
    },
  },
  title: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'unset',
      marginTop: theme.spacing(1),
    },
  },
  expandMore: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.BorderLight}`,
    borderRadius: theme.mixins.cornerRadius['border-radius-1000'],
  },
  body: {
    padding: 'unset',
  },
  summaryContainer: {
    flexDirection: 'column',
    display: 'flex',
  },
}))

export const SkillprintEmbed: React.FC = () => {
  const { userId } = useUserIdentityFn()
  const [expanded, setExpanded] = useState(false)
  const classes = useStyles()

  const handleClick = (
    _event: React.ChangeEvent<Record<string, unknown>>,
    isExpanded: boolean
  ): void => {
    setExpanded(isExpanded)

    if (isExpanded) {
      analytics.skillprintEmbedExpanded({
        timeStamp: new Date().toISOString(),
        userId: userId ?? '',
      })
    }
  }

  return (
    <Box
      className={classes.container}
      display="flex"
      flexDirection="column"
      my={3}
    >
      <Accordion expanded={expanded} onChange={handleClick}>
        <AccordionSummary
          expandIcon={
            <Box className={classes.expandMore} height={38} width={38}>
              <CaretDown />
            </Box>
          }
        >
          <Box className={classes.summaryContainer}>
            <NxTypography variant="h3">Try Skillprint</NxTypography>
            <Box pt={2}>
              <NxTypography variant="subtitle1">
                Discover your gaming strengths and weaknesses with Skillprint.
                Powered by Skillprint.
              </NxTypography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.body}>
          <iframe
            id="skillprintFrame"
            src="https://marketplace.staging.skillprint.co/discover"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
            title="Skillprint"
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
